import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

function CreateEntry() {
  const [isStudent, setIsStudent] = useState(true);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const navigate = useNavigate();

  const StudentForm = () => {
    const [name, setName] = useState('');
    const [date, setDate] = useState(new Date());
    const [concern, setConcern] = useState('Vomiting');
    const [status, setStatus] = useState('Sent Home');
    const [classGroup, setClassGroup] = useState('Cubs');
    const [notes, setNotes] = useState('');

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const docRef = await addDoc(collection(db, 'studentHealthEntries'), {
          name, date, concern, status, class: classGroup, notes,
        });
        console.log('Student concern added with ID: ', docRef.id);
        setShowSuccessMessage(true);
        setTimeout(() => {
          setShowSuccessMessage(false);
          navigate('/create-entry');
        }, 3000);
      } catch (error) {
        console.error('Error adding student concern: ', error);
      }
    };

    return (
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 p-4">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
            Name
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="date">
            Date
          </label>
          <DatePicker
            selected={date}
            onChange={(date) => setDate(date)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="concern">
            Concern
          </label>
          <select
            id="concern"
            value={concern}
            onChange={(e) => setConcern(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          >
            <option value="Vomiting">Vomiting</option>
            <option value="Virus">Virus</option>
            <option value="Hand/Foot in Mouth">Hand/Foot in Mouth</option>
            <option value="RSV">RSV</option>
            <option value="Covid">Covid</option>
            <option value="Strep Throat">Strep Throat</option>
            <option value="Fever">Fever</option>
            <option value="Diarrhea">Diarrhea</option>
            <option value="Eye Discharge">Eye Discharge</option>
            <option value="Rash">Rash</option>
            <option value="Sore Throat">Sore Throat</option>
            <option value="Flu">Flu</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="class">
            Class
          </label>
          <select
            id="class"
            value={classGroup}
            onChange={(e) => setClassGroup(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          >
            <option value="Cubs">Cubs</option>
            <option value="Teddies">Teddies</option>
            <option value="Koalas">Koalas</option>
            <option value="Pandas 201">Pandas 201</option>
            <option value="Pandas 202">Pandas 202</option>
            <option value="Preschool 301">Preschool 301</option>
            <option value="Preschool 302">Preschool 302</option>
            <option value="Pre-K 501">Pre-K 501</option>
            <option value="Pre-K 402">Pre-K 402</option>
            <option value="Kindergarten 401">Kindergarten 401</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="status">
            Status
          </label>
          <select
            id="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          >
            <option value="Sent Home">Sent Home</option>
            <option value="Parent Informed">Parent Informed</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="notes">
            Notes
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="3"
          />
        </div>
        <div className="flex items-center justify-end">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="submit"
          >
            SUBMIT
          </button>
        </div>
      </form>
    );
  };

  const StaffForm = () => {
    const [name, setName] = useState('');
    const [date, setDate] = useState(new Date());
    const [concern, setConcern] = useState('Other');
    const [Class, setClass] = useState('Cubs');
    const [notes, setNotes] = useState('');

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const docRef = await addDoc(collection(db, 'staffHealthEntries'), {
          name, date, concern, Class, notes,
        });
        console.log('Staff concern added with ID: ', docRef.id);
        setShowSuccessMessage(true);
        setTimeout(() => {
          setShowSuccessMessage(false);
          navigate('/create-entry');
        }, 3000);
      } catch (error) {
        console.error('Error adding staff concern: ', error);
      }
    };

    return (
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 p-4">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
            Name
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="date">
            Date
          </label>
          <DatePicker
            selected={date}
            onChange={(date) => setDate(date)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="concern">
            Concern
          </label>
          <select
            id="concern"
            value={concern}
            onChange={(e) => setConcern(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          >
            <option value="Flu">Flu</option>
            <option value="Covid">Covid</option>
            <option value="Strep Throat">Strep Throat</option>
            <option value="Eye">Eye</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="Class">
            Class
          </label>
          <select
            id="class"
            value={Class}
            onChange={(e) => setClass(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          >
            <option value="Cubs">Cubs</option>
            <option value="Teddies">Teddies</option>
            <option value="Koalas">Koalas</option>
            <option value="Pandas 201">Pandas 201</option>
            <option value="Pandas 202">Pandas 202</option>
            <option value="Preschool 301">Preschool 301</option>
            <option value="Preschool 302">Preschool 302</option>
            <option value="Pre-K 501">Pre-K 501</option>
            <option value="Pre-K 402">Pre-K 402</option>
            <option value="Kindergarten 401">Kindergarten 401</option>
            <option value="Management">Management</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="notes">
            Notes
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="3"
          />
        </div>
        <div className="flex items-center justify-end">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="submit"
          >
            SUBMIT
          </button>
        </div>
      </form>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 p-8">Concern Entry Form</h1>
        {showSuccessMessage && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4" role="alert">
            <strong className="font-bold">Success!</strong>
            <span className="block sm:inline"> Entry has been submitted successfully.</span>
          </div>
        )}
        <div className="flex justify-center mb-6">
          <div className="inline-flex rounded-full p-2 bg-gray-200">
            <button
              onClick={() => setIsStudent(true)}
              className={`px-4 py-2 rounded-full ${
                isStudent
                  ? 'bg-blue-500 text-white'
                  : 'bg-transparent text-gray-700'
              } transition-colors duration-200`}
            >
              Student
            </button>
            <button
              onClick={() => setIsStudent(false)}
              className={`px-4 py-2 rounded-full ${
                !isStudent
                  ? 'bg-blue-500 text-white'
                  : 'bg-transparent text-gray-700'
              } transition-colors duration-200`}
            >
              Staff
            </button>
          </div>
        </div>
        {isStudent ? <StudentForm /> : <StaffForm />}
      </div>
    </div>
  );
}

export default CreateEntry;